const userDashboardHomeDictES = {
  bonus: "Renta diaria",
  balance: "Saldo",
  inbound: "Crédito",
  outbound: "Débito",
  every: "Cada",
  AmountIsAutomaticallyTransferredToWallet:
    " el monto se transfiere automáticamente a la billetera principal.",
  currentlyYouCan: "Actualmente puedes utilizar hasta ",
  ofYourExtracoin: " de tu saldo Extracrédito para pagar tus compras.",
  extracoinOnlyBetweenUsers: "Extracredit es sólo para compras y transferencias entre usuarios!",
  indirects: "Indirectos",
  stats: "Estadísticas",
  plan: "Plan",
  subscription: "Firma",
  daysLeft: " días restantes",
  activation: "Activación",
  seeAllDirects: "Ver todos los directos",
  youDontHaveAny: "Usted no tiene ninguno usuario directo en su círculo económico aún",
  days: "días",
  months: "meses",
  year: "año",
  numberOfUsersInNetwork: "Número de usuarios agregados a su red",
  date: "Fecha",
  monthNames: [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ],
  quantity: "Cuantidad",
  referralLinks: "Links de referencia",
  shareReferrals: "Compartir indicaciones",
  share: "Compartir",
  copy: "Copiar",
  copiedToClipboard: "Copiado para la área de transferencia.",
  copied: "Copiado",
  notActive: "Usuario inactivo",
  balanceCommission: "comisiones",
  balanceSale: "ventas",
  message: "Mensaje",
  imAware: "Estoy consciente",
  alert: "Alerta",
  notEnabled:
    "Su cuenta no puede enviar productos en este momento. Edite la dirección de su perfil a una dirección válida.",
  inAnalysis:
    "Su dirección de recogida del paquete proporcionada está siendo analizada actualmente.",
  enabled: "La dirección de recogida del paquete proporcionada es apta para enviar productos.",
  thisIsPickupAddress:
    "Esta dirección será utilizada por las empresas de envío para recoger sus paquetes",
  renewSubscriptionValue: "Renovar valor de la suscripción",
  referralLinksExplanation:
    "Utilice estos enlaces para registrar nuevos usuarios en los distintos planes y aumente automáticamente su círculo económico ganando comisiones e ingresos diarios según nuestro plan de compensación.",
  profile: "Perfil",
  activationRequirements: "Para la activación se requiere 1 registro o 1 compra por mes.",
  safePayment: "Pago seguro",
  balanceForExternalAds: "Saldo para anuncios externos",
  youCanUseThisAmountToMakeExternalAds: "Puede utilizar este saldo para hacer anuncios externos",
  transaction: "Transacción",
  transactions: "Transacciones",
  create: "Crea",
  qrCodeOfTransaction: "Qr Code de la transacción",
  paymentDate: "Fecha de pago",
  payWithExtracredit: "Pagando con Extracrédito",
  payWithWallet: "Pagando con Wallet",
  sumOfValuesIsDifferent: "La suma de los valores es diferente del valor de la transacción.",
  transactionDone: "Transacción realizada con éxito!",
  to: "A",
  awaitingPayment: "Esperando pago",
  payer: "Pagador",
  idOfTransaction: "ID de transacción",
  makeAnotherPayment: "Realizar otro pago",
  qrcodereferralLinks: "Qr Code del link de referencia",
  economicCircle: "Círculo económico",
  yourNetworkOfInfluence: "Tu red de influencia",
  close: "Cerrar",
  members: "Miembros",
  viewNetwork: "Ver red",
  networkCommissionLabel: "Comisión de red",
  dailyIncomeLabel: "Ingresos diarios",
  networkReferralCommissionLabel: "Comisión por referidos",
  networkReferralCommissionInfo: "Comisiones recibidas cuando personas de tu red (referidos directos e indirectos) compran un plan. No incluye tus ingresos propios.",
  networkSalesCommissionLabel: "Comisión por ventas",
  networkSalesCommissionInfo: "Comisiones recibidas sobre compras, ventas y transferencias realizadas por personas de tu red. No incluye lo que ganas con tus propias ventas.",
  roleCustomer: "Customer",
  rolePromoter: "Promoter",
  roleManager: "Manager",
  roleManagerAssociation: "Manager Association",
  rolePartner: "Partner",
  roleSeller: "Seller",
  roleStore: "Store",
  doTheDiagnosis: "Partícipa en la Evaluación",
  associationConfimeaShareTitle: "Enlace Business Square",
  associationConfimeaShareDescription:
    "Comparte este enlace para que nuevos Managers se registren usando el documento de tu asociación.",
};

export default userDashboardHomeDictES;
